import axios from 'axios'
import { DeleteFolderResponse } from '../../types/folder'
import { getExternalReference } from '../getExternalReference'

export const deleteFolder = async (id: number): Promise<boolean> => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND

    if (!backendUrl) {
      console.error('REACT_APP_BACKEND environment variable is not defined')
      return false
    }

    const token = localStorage.getItem('@realize: accessToken')
    if (!token) {
      console.error('No authorization token found')
      return false
    }

    const externalReference = getExternalReference(backendUrl)

    await axios.delete<DeleteFolderResponse>(
      `${backendUrl}/n8n/mavis/folders/${id}`,
      {
        params: {
          external_reference: externalReference
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )

    return true
  } catch (error) {
    console.error('Unexpected error:', error)
    return false
  }
}
